/******************************************************************************************
 *	License Admin Search Snapshot
 *******************************************************************************************
 *
 * Offers persistence for License Admins search results data, sorting and paging.
 *
 */
(function() {
  

  angular
    .module('rcServices.licenseAdminSearchSnapshot', [])
    .service('LicenseAdminSearchSnapshot', function() {
      var resultsSspList = null;
      var searchCriteria = null;
      var searchTerm = null;

      this.setSearchResults = function(data) {
        resultsSspList = data;
      };
      this.getSearchResults = function() {
        return resultsSspList;
      };

      this.setSearchCriteria = function(data) {
        searchCriteria = data;
      };
      this.getSearchCriteria = function() {
        return searchCriteria;
      };

      this.setSearchTerm = function(data) {
        searchTerm = data;
      };
      this.getSearchTerm = function() {
        return searchTerm;
      };

      this.clear = function() {
        resultsSspList = null;
        searchCriteria = null;
        searchTerm = null;
      };
    });
})();
